<template lang="pug">
  v-dialog(v-model="show" max-width="700" persistent :fullscreen="$vuetify.breakpoint.smAndDown" scrollable)
    v-snackbar(v-model="showSnackBar" :color="snackBarColor") {{ snackBarMessage }}
      template(v-slot:action="{ attrs }")
        v-btn.justify-end(fab text v-bind="attrs" @click="showSnackBar = false")
          v-icon fal fa-times-circle
    v-card.pa-0
      v-card-title {{$t('boarderManagementPage.printQRcode')}}
      v-card-text(style=" margin-top: 6mm;" v-if="$vuetify.breakpoint.mdAndUp")
        v-row.ma-0.pt-3.mt-4(v-for="page in pages" :key="page")
          v-col.text-center.subtitle-1.pt-0(cols="12") {{$t('boarderManagementPage.selectedContainerTitle')}}
          v-col.text-center.pt-0(cols="12")
            v-btn(disabled) {{page}}
          v-col.pa-0(v-for="item in getFilteredIndexList(page)" :key="item.id" cols="4" style="flex: 1 0 33.33%; width: 66mm;")
            v-card.elevation-2(id="cardId" outlined tile class="pa-15 no-resize" @click="onSelectedItemClick(item)"
              :class="{ 'color': item.isSelected }" style="flex: 1 0 25%" )
              v-row.ma-0(v-if="!item.isSelected" style="position: absolute; top: 6mm; left: 6mm; bottom: 4mm")
                v-icon.ma-0.text-center.justify-content-center.align-items-center.pt-1(large :class="item.icon" style="position: absolute; top: 8mm; left: 16mm; bottom: 8mm")

      v-card-text.pa-0.pl-2.pr-2(style=" margin-top: 6mm;" v-else)
        v-row.ma-0.pt-3.mt-4(v-for="page in pages" :key="page")
          v-col.text-center.subtitle-1.pt-0(cols="12") {{$t('boarderManagementPage.selectedContainerTitle')}}
          v-col.text-center(cols="12")
            v-btn(disabled) {{page}}
          v-col.pa-0(v-for="item in getFilteredIndexList(page)" :key="item.id" cols="4"  style="flex: 1 0 33.33%; height: 30mm;")
            v-card.elevation-2(id="cardId" outlined tile class="pa-11 no-resizeXS" @click="onSelectedItemClick(item)"
              :class="{ 'color': item.isSelected }" style="flex: 1 0 25%" )
              v-row.ma-0.justify-center.container-style(v-if="!item.isSelected" )
                v-col.text-center.pa-0(cols="12" )
                  v-icon.ma-0.text-center(large :class="item.icon" )

      v-divider
      v-card-actions
        v-spacer
        v-btn( color="primary" text @click="onCancelButtonClick" :disabled="inProgress || fetchInProgress" ) {{ $t('boarderManagementPage.cancelButtonLabel') }}
        v-btn(color="primary" @click="onSubmitButtonClick" :disabled="inProgress || fetchInProgress" :loading="showResetLoader") {{$t('boarderManagementPage.submitCreditButtonLabel') }}

</template>

<script lang="ts">

import {Component, Prop,} from "vue-property-decorator";
import Vue from 'vue';
import {BoarderResponse} from "@/types/service-response";
import jsPDF from "jspdf";
import {Action} from "vuex-class";
import {FETCH_BOARDER_QRCODE} from "@/store/action-types";
import QRCode from 'qrcode-generator'

@Component({
  components: {
  }
})

export default class QrCodeDialog extends Vue {

  @Prop({type: Boolean, default: false}) readonly show!: boolean
  @Prop({type: Array, required: true}) readonly selectedBoarderList!: BoarderResponse[]
  @Action(FETCH_BOARDER_QRCODE) fetchUserOrCode!: ({ (payload: number[]): Promise<any> })


  private inProgress: boolean = false
  private cardId: string = ''
  private index: any[] = []
  private value: string[] = []
  private boarderName: string[] = []
  private rowIndex: number = 0;
  private colIndex: number = 0;
  private boarderIndex: number = 0
  private pages: number = 1
  private showResetLoader: boolean = false
  private showSnackBar: boolean = false
  private snackBarColor: string = ''
  private snackBarMessage: string = ''
  private fetchInProgress: boolean = false



  getFilteredIndexList (page: number): any[] {
    const start: number = 1
    const end: number = 24
    return this.index.filter((item: any) => item.id >= start+((page-1) * 24 ) && item.id <= end+((page-1) * 24 ))
  }

  getColor(item: any) {
    return item.color
  }

  onSelectedItemClick(item: any) {
    const foundItem: any = this.index.find((i:any) => i.id === item.id)
    if(foundItem) {
      foundItem.isSelected = !foundItem.isSelected
      if(foundItem.isSelected) {
        foundItem.icon = ''
        const freeIndexCount: number = this.index.filter((i: any) => !i.isSelected).length
          if(freeIndexCount < this.value.length) {
            const count: number = this.index.length
            for (let i = 1; i < 25; i++) {
              this.index.push({id: count + i, color: '', icon: '', isSelected: false,printPosition: { rowIndex: null, colIndex: null }})
            }

            this.pages += 1
          }

          const filteredIndexList = this.index.filter((i:any) => i.icon === 'fas fa-user-circle')
          if(filteredIndexList.length < this.selectedBoarderList.length) {
            let foundItem = this.index.find((a:any) => !a.isSelected && a.icon === '')
            if(foundItem) {
              foundItem.icon = 'fas fa-user-circle'
            }
          }
      } else {
        const filteredIndexList = this.index.filter((i:any) => i.icon === 'fas fa-user-circle')
        this.index[filteredIndexList.length -1].icon = ''
      }
    }
  }

  onResetButtonClick(): void {
    this.showResetLoader = true
    this.boarderIndex = 0;
    this.rowIndex = 0;
    this.colIndex = 0;

    setTimeout(() => {
      this.showResetLoader = false;
    }, 1000);
  }

  async onSubmitButtonClick(): Promise<void> {
    this.inProgress = true
    this.onResetButtonClick()

    const fontData = await this.fetchFont()

    const pdf = new jsPDF({
      orientation: 'portrait',
    });

    const itemsPerRow = 3;
    const itemsPerCol = 8;
    const cellWidth = 66;
    const cellHeight = 33.8;
    const marginLeft = 0;
    const marginRight = 0;
    const marginTop =0;
    const marginBottom = 0;

    let rowIndex = 0;
    let colIndex = 0;

    const cycleTimes: number = this.value.length + this.index.filter((item: any) => item.isSelected).length

    for (let i = 0; i < cycleTimes; i++) {
      if(this.boarderIndex > this.value.length -1) {
        break
      }

      if (colIndex >= itemsPerRow) {
        colIndex = 0;
        rowIndex++;
      }

      if (rowIndex === 8) {
        pdf.addPage();
        rowIndex = 0;
        colIndex = 0;
      }

      const x = colIndex * (cellWidth + marginLeft + marginRight) + marginLeft;
      const y = rowIndex * (cellHeight + marginTop + marginBottom) + marginTop;
      const qrCodeValue = this.value[this.boarderIndex];
      const additionalText: string = this.boarderName[this.boarderIndex];
      this.generateQRcode(pdf, x, y, qrCodeValue, additionalText, marginRight, marginBottom, cycleTimes, fontData, rowIndex, colIndex);
      colIndex++;
    }

    pdf.save('moje-qr-kody.pdf');
    this.inProgress = false
  }

  generateQRcode(pdf: any, x: number, y: number, qrCodeValue: string, additionalText: string, marginRight: number, marginBottom: number, cycleTimes: number, fontData: string, rowIndex: number, colIndex: number): void {
    const cellWidth = 66;
    const cellHeight = 33.8;
    const qrWidth = 27;
    const qrHeight = 27;
    const xOffset = 3;
    const yOffset = 3.9;
    const paddingTop = 13

    const index = this.rowIndex * 3 + this.colIndex;

    if (index < cycleTimes) {
      if(!this.index[index]){
        this.index.push({id: index+1, color: '', icon: 'fas fa-user-circle', isSelected: false,printPosition: { rowIndex: null, colIndex: null }},)
      }
      const isCellSelected = this.index[index].isSelected;

      if (!isCellSelected) {
        this.boarderIndex += 1
        if (x + cellWidth + marginRight <= pdf.internal.pageSize.getWidth() && y + cellHeight + marginBottom <= pdf.internal.pageSize.getHeight()) {
          const qr = QRCode(0, 'H');
          qr.addData(qrCodeValue);
          qr.make();

          const imgData = qr.createDataURL(4, 0);
          pdf.addImage(imgData, 'PNG', x + xOffset + 6, y + yOffset + paddingTop, qrWidth, qrHeight);
          pdf.addFileToVFS('DejaVuSans.ttf', fontData)
          pdf.addFont('DejaVuSans.ttf', 'DejaVu Sans', 'normal')
          pdf.setFont('DejaVu Sans', 'normal')
          pdf.setFontSize(10);

          let textLines: any | null = null;
          const lineHeight = 5;
          const additionalSpace: number = 3;
          const splitTextToSize = pdf.splitTextToSize(additionalText, 27);

          if (splitTextToSize.length > 1) {
            textLines = pdf.splitTextToSize(additionalText, 27, 19);
            const firstLineY = y + qrHeight - additionalSpace;
            textLines = textLines.map((line: any, index: number) => ({
              text: line,
              y: firstLineY - (textLines.length - index - 1) * lineHeight
            }));
          } else {
            textLines = [{ text: additionalText, y: y + qrHeight - 5 }];
          }
          textLines.forEach((line: any, index: number) => {
            const lineHeight = 5;
            const textHeight = textLines.length * lineHeight;
            const textY = y + 20 + qrHeight - textHeight + index * lineHeight;
            const textX = x + xOffset + 34;

            pdf.text(line.text, textX, textY);
          });
        }
      }
      this.colIndex++;

      if ((this.colIndex >= 3 && index < this.value.length - 1) || (this.rowIndex === 8 && this.colIndex === 3)) {
        this.colIndex = 0;
        this.rowIndex++;
      }
    }
  }


  onCancelButtonClick () {
    this.$emit('close')
  }
  initDialog() {
    let count: number = 24

    if(this.selectedBoarderList.length > 24) {
      this.pages = Math.ceil(this.selectedBoarderList.length / count)
    }

    this.index = Array.from({ length: this.pages * count }, (_, id) => ({
      id: id + 1,
      color: '',
      icon: id < this.selectedBoarderList.length ? 'fas fa-user-circle' : '',
      isSelected: false,
      printPosition: { rowIndex: null, colIndex: null },
    }));


  this.value =[]
  }

  async fetchFont (): Promise<string> {
    const fontFileUrl = require('@/assets/fonts/DejaVuSans.ttf')

    const response = await fetch(fontFileUrl)
    const fontBlob = await response.blob()

    return new Promise((resolve, reject) => {
      const reader = new FileReader()

      reader.onload = function (event) {
        if (event.target && typeof event.target.result === 'string') {
          const base64Font = event.target.result.split(',')[1]

          resolve(base64Font)
        } else {
          reject(new Error('Failed to read font file as data URL'))
        }
      }

      reader.onerror = function () {
        reject(new Error('Error reading font file'))
      }

      reader.readAsDataURL(fontBlob)
    })
  }

  async fetchBoarderQrCode(): Promise<void> {
    let payload: number[] | [] = this.selectedBoarderList.map((item: BoarderResponse) => item.id)
    try {
      this.fetchInProgress = true
     const response: any = await this.fetchUserOrCode(payload)
      this.value = response.map((item: any) => 'https://lunchmenu.today/' + item.code)
      this.boarderName = response.map((item: any) => item.boarder.person.firstName + ' ' + item.boarder.person.familyName)
    } catch (e) {
      this.showSnackBar = true
      this.snackBarColor = 'error'
      this.snackBarMessage = this.$t('errors.fetchDataError').toString()
    } finally {
      this.fetchInProgress = false
    }
  }

  mounted() {
    this.initDialog()
    this.fetchBoarderQrCode()
  }

}

</script>

<style lang="stylus" scoped>
.container-style
  align-content center
  align-items center
  align-self center
  justify-content center

.color
  background-color: #ff5252

.no-resize
  width: 100% !important
  height: 100% !important
.no-resizeXS
  width: 100% !important
  height: 100% !important

</style>
